import { Col, Input, Label, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import SelectCustomStyles from "../../../../../utils/styles/reactSelect";
import countries, { countryCodeOptions } from "../../../../../data/countries";
import DateTimeInput from "../../../../../components/Forms/DateTimeInput";

function PersonalTab({ employeeData, setEmployeeData }) {
  const { t } = useTranslation();
  
  return(
    <Row>
      <Col md="4" className="mb-3">
        <Label>{t('contact.firstName')} <span className="text-danger">*</span></Label>
        <Input 
          value={employeeData.firstname || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, firstname: e.target.value })}
          autoComplete="off"
        />
      </Col>
      <Col md="4" className="mb-3">
        <Label>{t('profile.middleName')}</Label>
        <Input 
          value={employeeData.middlename || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, middlename: e.target.value })}
        />
      </Col>
      <Col md="4" className="mb-3">
        <Label>{t('contact.lastName')} <span className="text-danger">*</span></Label>
        <Input 
          value={employeeData.lastname || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, lastname: e.target.value })}
        />
      </Col>

      <Col md="6" className="mb-3">
        <Label>{t('hr.gender')} </Label>
        <Input type="select" value={employeeData.gender || ''} onChange={(e) => setEmployeeData({ ...employeeData, gender: e.target.value })}>
          <option value="">{t('hr.selectGender')}</option>
          <option value="male">{t('hr.male')}</option>
          <option value="female">{t('hr.female')}</option>
        </Input>
      </Col>

      <Col md="6" className="mb-3">
        <Label>{t('hr.dateOfBirth')}</Label>
        <DateTimeInput 
          value={employeeData.birthdate}
          onChange={(date) => setEmployeeData({ ...employeeData, birthdate: date })}
          maxDate={new Date(new Date().setFullYear(new Date().getFullYear() - 18))}
        />
      </Col>

      <Col md="6" className="mb-3">
        <Label>{t('hr.maritalStatus')} </Label>
        <Input type="select" value={employeeData.marital_status || ''} onChange={(e) => setEmployeeData({ ...employeeData, marital_status: e.target.value })}>
          <option value="">Select</option>
          <option value="single">{t('hr.single')}</option>
          <option value="married">{t('hr.married')}</option>
          <option value="divorced">{t('hr.divorced')}</option>
          <option value="widowed">{t('hr.widowed')}</option>
        </Input>
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('hr.bloodGroup')} </Label>
        <Input type="select" value={employeeData.blood_group || ''} onChange={(e) => setEmployeeData({ ...employeeData, blood_group: e.target.value })}>
          <option value="">Select</option>
          <option value="A+">A+</option>
          <option value="A-">A-</option>
          <option value="B+">B+</option>
          <option value="B-">B-</option>
          <option value="AB+">AB+</option>
          <option value="AB-">AB-</option>
          <option value="O+">O+</option>
          <option value="O-">O-</option>
        </Input>
      </Col>

      <h5 className="fw-bold mt-4">{t('hr.idDetails')}</h5>

      <Col md="6" className="mb-3">
        <Label>{t('hr.idType')} </Label>
        <Input type="select" value={employeeData.id_type || ''} onChange={(e) => setEmployeeData({ ...employeeData, id_type: e.target.value })}>
          <option value="national_id">{t('hr.nationalId')}</option>
          <option value="driver_license">{t('hr.driversLicense')}</option>
          <option value="passport">{t('hr.passport')}</option>
        </Input>
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('hr.idNumber')} </Label>
        <Input 
          value={employeeData.id_number || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, id_number: e.target.value })}
        />
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('hr.idIssueDate')} </Label>
        <DateTimeInput 
          value={employeeData.id_issue_date}
          onChange={(date) => setEmployeeData({ ...employeeData, id_issue_date: date })}
        />
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('hr.idExpiryDate')} </Label>
        <DateTimeInput 
          value={employeeData.id_expiry_date}
          onChange={(date) => setEmployeeData({ ...employeeData, id_expiry_date: date })}
        />
      </Col>

      <h5 className="fw-bold mt-4">{t('common.address')}</h5>

      <Col md="6" className="mb-3">
        <Label>{t('address.street')}: </Label>
        <Input
          value={employeeData.address || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, address: e.target.value })}
        />
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('address.city')}: </Label>
        <Input 
          value={employeeData.city || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, city: e.target.value })}
        />
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('settings.state')}: </Label>
        <Input 
          value={employeeData.state || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, state: e.target.value })}
        />
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('settings.postalCode')}: </Label>
        <Input 
          value={employeeData.postal_code || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, postal_code: e.target.value })}
        />
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('common.country')}: </Label>
        <Select
          name="country"
          value={countries.map(c => ({ value: c.slug, label: c.name })).find(o => o.value === employeeData.country) || null}
          onChange={(selected) => setEmployeeData({ ...employeeData, country: selected ? selected.value : '' })}
          options={
            countries.map((country) => (
              { value: country.slug, label: country.name }
            ))
          }
          styles={SelectCustomStyles}
        />
      </Col>

      <h5 className="fw-bold mt-4">{t('hr.contact')}</h5>

      <Col md="6" className="mb-3">
        <Label>{t('common.phone')} </Label>
        <div className="d-flex gap-2">
          <div style={{ width: 140, flexShrink: 0 }}>
            <Select
              options={countryCodeOptions}
              value={countryCodeOptions.find((o) => o.value === employeeData.country_code) || null}
              onChange={(selected) =>
                setEmployeeData({ ...employeeData, country_code: selected ? selected.value : '' })
              }
              styles={SelectCustomStyles}
            />
          </div>
          <Input
            type="tel"
            name="primary_phone"
            placeholder={t('settings.phoneNumber')}
            value={employeeData.phone_number}
            onChange={(e) => setEmployeeData({ ...employeeData, phone_number: e.target.value })}
          />
        </div>
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('common.email')} </Label>
        <Input 
          value={employeeData.email || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, email: e.target.value })}
        />
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('hr.emergencyContactName')} </Label>
        <Input 
          value={employeeData.emergency_contact_name || ''}
          onChange={(e) => setEmployeeData({ ...employeeData, emergency_contact_name: e.target.value })}
        />
      </Col>
      <Col md="6" className="mb-3">
        <Label>{t('hr.emergencyContactPhone')} </Label>
        <div className="d-flex gap-2">
          <div style={{ width: 140, flexShrink: 0 }}>
            <Select
              options={countryCodeOptions}
              value={countryCodeOptions.find((o) => o.value === employeeData.emergency_contact_country_code) || null}
              onChange={(selected) =>
                setEmployeeData({ ...employeeData, emergency_contact_country_code: selected ? selected.value : '' })
              }
              styles={SelectCustomStyles}
            />
          </div>
          <Input
            type="tel"
            name="primary_phone"
            placeholder={t('settings.phoneNumber')}
            value={employeeData.emergency_contact_phone_number}
            onChange={(e) => setEmployeeData({ ...employeeData, emergency_contact_phone_number: e.target.value })}
          />
        </div>
      </Col>
    </Row>
  );
}

export default PersonalTab;
